module.exports = __webpack_public_path__ + "media/img/home/clients-map/join-9e6568725751c2e8e4b58a0523ac8004.svg";